import { render } from "./ThumbnailItem.vue?vue&type=template&id=5fb9791e&ts=true"
import script from "./ThumbnailItem.vue?vue&type=script&lang=ts"
export * from "./ThumbnailItem.vue?vue&type=script&lang=ts"

import "./ThumbnailItem.vue?vue&type=style&index=0&id=5fb9791e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__